import { useMutation, useQuery } from '@tanstack/react-query';

import { userService } from '@/services/database';
import { UserPreference } from '@/types';

export const useUserPreferencesQuery = () => {
    return useQuery({
        queryKey: ['userPreferences'],
        queryFn: async () => {
            return userService.getPreferences();
        },
    });
};

export const useUpdateUserPreferencesMutation = () => {
    return useMutation({
        mutationFn: async (updates: Partial<UserPreference>) => {
            return userService.updatePreferences(updates.preferences ?? updates);
        },
    });
};
